import { createSlice } from '@reduxjs/toolkit';
import { initialState } from '../../../data/entitlement/erpSalesOrder/initialState.erpSearchAndRetrieveSalesOrder.data';
import { fetchAccountingGroupsData as fetchAccountingGroupsAPI } from '../../../apis/erpSalesOrderAPI';
import {
  ACTIONS_CUSTOMERS,
  ACTIONS_ERP_ORDERS,
} from '../../../constants/actionCreator';
import { createAsyncThunkWrapper } from '../../../services/common/asyncThunkWrapper';
import { byMultipleInputs as byMultipleInputsAPI } from '../../../apis/erpSalesOrderAPI';
import {
  createMasterCustomerNumber as createMasterCustomerNumberAPI,
  getImportStatus as getImportStatusAPI,
  getMappingType as getMappingTypeAPI,
  fetchSiteData as fetchSiteAPI,
  fetchErpSalesOrderSearch as fetchErpSalesOrderSearchAPI,
  fetchSiteTypes as fetchSiteTypesAPI,
} from '../../../apis/erpSalesOrderAPI';
import { ERP_SALES_ORDER } from '../../../constants';
import { act } from 'react';
export const fetchAccountingGroups = createAsyncThunkWrapper(
  ACTIONS_CUSTOMERS.FETCH_ACCOUNTING_GROUPS,
  fetchAccountingGroupsAPI
);
export const customerNameSmartSearchData = createAsyncThunkWrapper(
  ACTIONS_CUSTOMERS.SEARCH_PRODUCT_NAME_CONTAINS,
  byMultipleInputsAPI
);
export const getSearchByMultipleInputsParentGlobalModal =
  createAsyncThunkWrapper(
    ACTIONS_ERP_ORDERS.MASTER_CUSTOMER_NUMBER,
    createMasterCustomerNumberAPI
  );

export const getImportStatusData = createAsyncThunkWrapper(
  ACTIONS_ERP_ORDERS.IMPORT_STATUS,
  getImportStatusAPI
);

export const getMappingTypeData = createAsyncThunkWrapper(
  ACTIONS_ERP_ORDERS.MAPPING_TYPE,
  getMappingTypeAPI
);

export const fetchSites = createAsyncThunkWrapper(
  ACTIONS_ERP_ORDERS.NCR_SITE_ID,
  fetchSiteAPI
);

export const fetchErpSalesOrderSearch = createAsyncThunkWrapper(
  ACTIONS_ERP_ORDERS.SEARCH_ERP_ORDER,
  fetchErpSalesOrderSearchAPI
);
export const fetchSiteTypeData = createAsyncThunkWrapper(
  ACTIONS_ERP_ORDERS.SITE_TYPE,
  fetchSiteTypesAPI
);

const searchAndRetrieveSalesOrderSlice = createSlice({
  name: 'erpSearchAndRetrieveSalesOrder',
  initialState,
  reducers: {
    setResetAllValues: () => initialState,
    setImportStartdate: (state, action) => {
      state.importStartDate = action?.payload;
    },
    setImportTodate: (state, action) => {
      state.importToDate = action?.payload;
    },
    setShipStartdate: (state, action) => {
      state.shipStartDate = action?.payload;
    },
    setShipTodate: (state, action) => {
      state.shipToDate = action?.payload;
    },
    setHandleMappingType: (state, action) => {
      state.mappingType = action?.payload;
    },
    setHandleImportStatus: (state, action) => {
      state.importStatus = action?.payload;
    },
    setHandleOrderGroup: (state, action) => {
      state.orderGroup = action?.payload;
    },
    setImportStatusCompare: (state, action) => {
      state.importStatus2 = action?.payload;
    },
    setSelectedValue: (state, action) => {
      state.parentGlobalModal.parentGlobalModalMultipleInputs[
        action?.payload?.name
      ] = action?.payload?.value;
    },
    setErpSearch: (state, action) => {
      state[action.payload.key] = action?.payload?.value;
    },
    setHandleSelectedGridData: (state, action) => {
      state.ncrSiteId = action?.payload[0]?.id;
      state.psSiteCode = action?.payload[0]?.ps_site_code;
      state.siteSearchModal.openSiteModal = false;
      state.siteSearchModal.siteSearchForm =
        initialState.siteSearchModal.siteSearchForm;
    },
    setAccountingGroupModalClose: (state) => {
      state.accountingGroupModal.openAccountingGroupModal = false;
      state.accountingGroupModal.accountingGroupSearchForm =
        initialState.accountingGroupModal.accountingGroupSearchForm;
    },

    setAccountingGroupModalOpen: (state) => {
      state.accountingGroupModal.openAccountingGroupModal = true;
      state.accountingGroupModal.accountingGroupSearchForm =
        initialState.accountingGroupModal.accountingGroupSearchForm;
    },
    setParentGlobalCustomerNoModalOpen: (state) => {
      state.parentGlobalModal.openParentGlobalCustomerNoModal = true;
    },
    setParentGlobalCustomerNoModalClose: (state) => {
      state.parentGlobalModal.openParentGlobalCustomerNoModal = false;
    },
    setFormFields: (state, action) => {
      state.allSalesOrderItemsMustQuality = action?.payload;
    },
    setCustomerNameInputValue: (state, action) => {
      if (state.parentGlobalModal?.openParentGlobalCustomerNoModal) {
        state.parentGlobalModal.parentGlobalModalMultipleInputs[
          action?.payload?.name
        ] = action?.payload?.value;
      } else {
        state.selectedCustomerNameInputValue[action?.payload?.name] =
          action?.payload?.value;
      }
    },
    setDropDownValue: (state, action) => {
      if (state.parentGlobalModal?.openParentGlobalCustomerNoModal) {
        state.parentGlobalModal.parentGlobalModalDropDownValues[
          action?.payload?.name
        ] = action?.payload?.value;
      } else {
        state.dropDownValues[action?.payload?.name] = action?.payload?.value;
      }
    },

    setCustomerNameSearchTerm: (state, action) => {
      if (state.parentGlobalModal?.openParentGlobalCustomerNoModal) {
        state.parentGlobalModal.customerNameSearchTerm = action?.payload;
      } else {
        state.customerNameSearchTerm = action?.payload;
      }
    },
    setShowCustomernameSelectedValue: (state, action) => {
      if (state.parentGlobalModal?.openParentGlobalCustomerNoModal) {
        state.parentGlobalModal.showCustomernameSelectedValue = action?.payload;
      } else {
        state.showCustomernameSelectedValue = action?.payload;
      }
    },
    setSelectedParentGlobalGridRowsData: (state, action) => {
      state.parentGlobalModal.gridParentGlobalCustomerNoRowSelectedData =
        action?.payload;
      state.parentGlobalModal.gridParentGlobalGridRowSelectedCount =
        action?.payload?.length;
      state.globalCustomerNumber = action?.payload[0]?.psCustomerCode;
    },
    setSiteModalOpen: (state, action) => {
      state.siteSearchModal.openSiteModal = action?.payload;
    },
    setSiteModalClose: (state) => {
      state.siteSearchModal.openSiteModal = false;
      state.siteSearchModal.siteSearchForm =
        initialState.siteSearchModal.siteSearchForm;
    },
    //Site
    setSelectedSiteGridRowsData: (state, action) => {
      state.siteSearchModal.gridSiteRowSelectedData =
        action?.payload?.length > 0
          ? action.payload
          : ERP_SALES_ORDER.inputModalDefaultVal;
      state.siteSearchModal.gridSiteRowSelectedCount =
        action?.payload?.length > 0 ? action?.payload?.length : 0;

      state.requestBody.siteId = action?.payload[0]?.id
        ? action?.payload[0].id
        : 0;
    },
    setAccouningGroupFormFeilds: (state, action) => {
      state.accountingGroupModal.accountingGroupSearchForm[
        action?.payload?.name
      ] = action?.payload?.value;
    },
    setSiteFormFeilds: (state, action) => {
      state.siteSearchModal.siteSearchForm[action.payload.name] =
        action?.payload?.value;
    },

    //Accounting Modal
    setSelectedAccountGridRowsData: (state, action) => {
      if (state.parentGlobalModal?.openParentGlobalCustomerNoModal) {
        state.parentGlobalModal.parentGlobalModalMultipleInputs.accountingGroup =
          action?.payload[0]?.accountingGroupCode;
      } else {
        state.accountingGroup = action?.payload[0]?.accountingGroupCode;
      }

      state.erpSalesSearchModal.gridAccountingRowSelectedData =
        action?.payload?.length > 0
          ? action?.payload
          : ERP_SALES_ORDER.inputModalDefaultVal;
      state.erpSalesSearchModal.gridAccountingRowSelectedCount =
        action?.payload?.length > 0 ? action?.payload?.length : 0;
      state.contractsSearch.accountingGroupName = action?.payload[0]?.name
        ? action?.payload[0]?.name
        : ERP_SALES_ORDER.inputModalDefaultVal;
      state.contractsSearch.accountingGroupCode = action?.payload[0]
        ?.accountingGroupCode
        ? action?.payload[0]?.accountingGroupCode
        : '';
    },
    hanleAGChange: (state, action) => {
      state.accountingGroup = action?.payload;
      state.contractsSearch.accountingGroupCode = action?.payload;
    },
    hanleNCRSiteChange: (state) => {
      state.psSiteCode = initialState.psSiteCode;
      state.ncrSiteId = initialState.ncrSiteId;
    },
    setSearchParams: (state, action) => {
      state.siteSearchModal.siteSearchForm[action.payload.key] =
        action?.payload?.value;
    },
    setSelectedComponent: (state, action) => {
      state.selectedComponent = action?.payload;
      state.orderNumberSearch = '';
    },
    //erp Customer
    setSelectedCustomerGridRowsData: (state, action) => {
      state.loading = true;
      state.erpSalesSearchModal.gridCustomerRowSelectedData =
        action?.payload?.selectedRow?.length > 0
          ? action?.payload?.selectedRow
          : ERP_SALES_ORDER.inputModalDefaultVal;

      state.erpSalesSearchModal.gridCustomerRowSelectedCount =
        action?.payload?.selectedRow?.length > 0
          ? action?.payload?.selectedRow?.length
          : 0;
      action.payload.name == 'Customer'
        ? (state.siteSearchModal.siteSearchForm.corporateCustomer =
            action?.payload?.selectedRow[0]?.customerId || '') &&
          (state.siteSearchModal.siteSearchForm.ps_Customer_code =
            action?.payload?.selectedRow[0]?.psCustomerCode || '')
        : (state.siteSearchModal.siteSearchForm.billToCustomer =
            action?.payload.selectedRow[0]?.customerId || '') &&
          (state.siteSearchModal.siteSearchForm.bill_ps_Cutomer_code =
            action?.payload.selectedRow[0]?.psCustomerCode || '');
    },
    resetValues: (state) => {
      state.globalCustomerNumber = initialState.globalCustomerNumber;
      state.importStartDate = initialState.importStartDate;
      state.importToDate = initialState.importToDate;
      state.accountingGroup = initialState.accountingGroup;
      state.orderGroup = initialState.orderGroup;
      state.ncrSiteId = initialState.ncrSiteId;
      state.shipStartDate = initialState.shipStartDate;
      state.shipToDate = initialState.shipToDate;
      state.allSalesOrderItemsMustQuality =
        initialState.allSalesOrderItemsMustQuality;
      state.importStatus2 = initialState.importStatus2;
      state.importStatus = initialState.importStatus;
      state.mappingType = initialState.mappingType;
      state.orderNumberSearch = initialState.orderNumberSearch;
      state.psSiteCode = initialState.psSiteCode;
    },
    setSelectedSingleRow: (state, action) => {
      state.selectSingleRow = action?.payload;
    },
    setDisplayButtonValue: (state, action) => {
      state.displayButtonValue = action?.payload;
      state.erpOrderSearchData['salesOrders'] = action?.payload
        ? [action?.payload]
        : [];
      state.erpFastFindDataFound = true;
    },
    setOrderNumberSearch: (state, action) => {
      state.orderNumberSearch = action?.payload?.value;
    },
    setIsAlertShow: (state, action) => {
      state.isAlertShow = action?.payload;
    },
    setBackToPage: (state, action) => {
      state.erpFastFindDataFound = action?.payload;
    },
    resetOnReturn: (state) => {
      state.erpFastFindDataFound = false;
    },
    handleCallSearch: (state, action) => {
      state.callSearch = action?.payload;
    },
    setCustomerModal: (state, action) => {
      state.customerModal = action?.payload;
    },
    setBillToCustomerModal: (state, action) => {
      state.billCustomerModal = action?.payload;
    },
    setCustomerNumber: (state, action) => {
      state.globalCustomerNumber = action?.payload;
    },
    resetErpOrderSearchData: (state) => {
      state.erpOrderSearchData = [];
    },
    setErpManualOrder_SaR: (state, action) => {
      if (state.erpOrderSearchData?.salesOrders?.length) {
        state.erpOrderSearchData.salesOrders[0].comment =
          action?.payload?.value;
      }
    },
    resetValuesMultipleInput: (state) => {
      state.globalCustomerNumber = initialState.globalCustomerNumber;
      state.importStartDate = initialState.importStartDate;
      state.importToDate = initialState.importToDate;
      state.accountingGroup = initialState.accountingGroup;
      state.orderGroup = initialState.orderGroup;
      state.ncrSiteId = initialState.ncrSiteId;
      state.shipStartDate = initialState.shipStartDate;
      state.shipToDate = initialState.shipToDate;
      state.allSalesOrderItemsMustQuality =
        initialState.allSalesOrderItemsMustQuality;
      state.importStatus2 = initialState.importStatus2;
      state.importStatus = initialState.importStatus;
      state.mappingType = initialState.mappingType;
      state.psSiteCode = initialState.psSiteCode;
    },
    resetCustomerModalValues: (state) => {
      state.parentGlobalModal.showCustomernameSelectedValue = '';
      state.parentGlobalModal.parentGlobalModalMultipleInputs.accountingGroup =
        '';
      state.parentGlobalModal.parentGlobalModalMultipleInputs.parentPsCustomerCode =
        '';
      state.parentGlobalModal.parentGlobalModalDropDownValues.activeFlag = 'a';
      state.parentGlobalModal.parentGlobalModalDropDownValues.corporateCustomer =
        'a';
      state.parentGlobalModal.parentGlobalModalDropDownValues.billtoCustomer =
        'a';
      state.globalCustomerModalGridData = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAccountingGroups.pending, (state) => {
        state.isAccountingGroupsResultsFound = false;
        state.accountingGroupModal.accountingGroupSearchData = [];
        state.loading = true;
      })
      .addCase(fetchAccountingGroups.fulfilled, (state, action) => {
        state.loading = false;
        if (action?.payload?.accountingGroups?.length > 0) {
          state.accountingGroupModal.accountingGroups = action?.payload;
          state.accountingGroupModal.accountingGroupSearchData =
            action?.payload?.accountingGroups;
          state.accountingGroupModal.accountingGroupGridTotalRecords =
            action?.payload ? action?.payload?.totalCount : 0;
          state.isAccountingGroupsResultsFound = true;
        } else {
          state.accountingGroupModal.accountingGroups = [];
          state.accountingGroupModal.accountingGroupSearchData = [];
          state.accountingGroupModal.accountingGroupGridTotalRecords = 0;
          state.isAccountingGroupsResultsFound = true;
        }
      })
      .addCase(fetchAccountingGroups.rejected, (state) => {
        state.accountingGroupModal.accountingGroupSearchData = [];
        state.accountingGroupModal.accountingGroups = [];
        state.accountingGroupModal.accountingGroupGridTotalRecords = 0;
        state.isAccountingGroupsResultsFound = true;
        state.loading = false;
      })

      .addCase(getSearchByMultipleInputsParentGlobalModal.pending, (state) => {
        state.globalcustLoad = true;
        state.customerGridDataFound = false;
        state.globalCustomerModalGridData = [];
      })
      .addCase(
        getSearchByMultipleInputsParentGlobalModal?.fulfilled,
        (state, action) => {
          state.globalcustLoad = false;
          state.customerGridDataFound = true;
          state.globalCustomerModalGridData = action?.payload
            ? action?.payload
            : [];
          state.parentGlobalGridTotalRecords = action?.payload
            ? action?.payload[0]?.totalRecords
            : 0;
        }
      )
      .addCase(getSearchByMultipleInputsParentGlobalModal.rejected, (state) => {
        state.customerGridDataFound = false;
        state.globalcustLoad = false;
        state.globalCustomerModalGridData = [];
      })
      .addCase(getImportStatusData.pending, (state) => {
        state.loading = true;
      })
      .addCase(getImportStatusData.fulfilled, (state, action) => {
        state.loading = false;
        state.importStatusListData = action?.payload ? action?.payload : [];
      })
      .addCase(getImportStatusData.rejected, (state) => {
        state.loading = false;
      })

      .addCase(getMappingTypeData.pending, (state) => {
        state.loading = true;
      })
      .addCase(getMappingTypeData.fulfilled, (state, action) => {
        state.loading = false;
        state.mappingTypeData = action?.payload ? action?.payload : [];
      })
      .addCase(getMappingTypeData.rejected, (state) => {
        state.loading = false;
      })

      .addCase(fetchSites.pending, (state) => {
        state.loading = true;
        state.siteSearchModal.siteSearchData = [];
        state.isSitesResultsFound = false;
      })
      .addCase(fetchSites.fulfilled, (state, action) => {
        state.loading = false;
        state.siteSearchModal.sites = action?.payload?.sites;
        state.siteSearchModal.siteSearchData = action?.payload;
        state.siteSearchModal.siteGridTotalRecords = action?.payload
          ? action?.payload?.sites[0]?.totalRecords
          : 0;
        state.isSitesResultsFound = action?.payload
          ? action?.payload?.sites[0]?.totalRecords > 0
          : false;
        if (action?.payload === null) {
          state.isSitesResultsFound = true;
        }
      })
      .addCase(fetchSites.rejected, (state) => {
        state.siteSearchModal.siteSearchData = [];
        state.siteSearchModal.siteGridTotalRecords = 0;
        state.isSitesResultsFound = false;
      })
      .addCase(fetchErpSalesOrderSearch.pending, (state) => {
        state.erpSalesOrderLoading = true;
        state.erpOrderSearchData = [];
        state.erpFastFindDataFound = false;
        state.isAlertShow = false;
      })
      .addCase(fetchErpSalesOrderSearch.fulfilled, (state, action) => {
        state.loading = false;
        state.erpSalesOrderLoading = false;

        state.erpOrderSearchData = action?.payload;
        state.selectedComponent !== ERP_SALES_ORDER.radioButtonWithProductCode
          ? (state.erpFastFindDataFound = false)
          : (state.erpFastFindDataFound =
              action?.payload?.totalRecords != null ? true : false);
        if (state.erpOrderSearchData?.salesOrders?.length === 0) {
          state.isAlertShow = true;
        } else {
          state.isAlertShow = false;
        }
      })
      .addCase(fetchErpSalesOrderSearch.rejected, (state) => {
        state.loading = false;
        state.erpOrderSearchData = [];
        state.selectedComponent !== ERP_SALES_ORDER.radioButtonWithProductCode
          ? (state.erpFastFindDataFound = false)
          : null,
          (state.isAlertShow = true);
        state.erpSalesOrderLoading = false;
      })

      .addCase(fetchSiteTypeData.pending, (state) => {
        state.siteType = [];
      })
      .addCase(fetchSiteTypeData.fulfilled, (state, action) => {
        state.siteType = action?.payload;
      })
      .addCase(fetchSiteTypeData.rejected, (state) => {
        state.siteType = [];
      })

      .addCase(customerNameSmartSearchData.pending, (state) => {
        state.smartSearchData = [];
      })
      .addCase(customerNameSmartSearchData.fulfilled, (state, action) => {
        state.smartSearchData = action?.payload || [];
      })
      .addCase(customerNameSmartSearchData.rejected, (state) => {
        state.smartSearchData = [];
      });
  },
});

export const {
  setImportStartdate,
  setImportTodate,
  setShipStartdate,
  setShipTodate,
  setSelectedValue,
  setAccountingGroupModalClose,
  setAccountingGroupModalOpen,
  setParentGlobalCustomerNoModalClose,
  setParentGlobalCustomerNoModalOpen,
  setFormFields,
  setCustomerNameInputValue,
  setDropDownValue,
  setCustomerNameSearchTerm,
  setShowCustomernameSelectedValue,
  setSelectedParentGlobalGridRowsData,
  setHandleImportStatus,
  setHandleMappingType,
  setImportStatusCompare,
  setSiteModalOpsetSiteModalCloseen,
  setSiteModalClose,
  setSiteModalOpen,
  setSelectedSiteGridRowsData,
  setAccouningGroupFormFeilds,
  setSiteFormFeilds,
  setSelectedAccountGridRowsData,
  setSearchParams,
  setHandleSelectedGridData,
  setErpSearch,
  setSelectedComponent,
  setSelectedCustomerGridRowsData,
  setHandleOrderGroup,
  setSelectedSingleRow,
  setDisplayButtonValue,
  setResetAllValues,
  setOrderNumberSearch,
  setIsAlertShow,
  setBackToPage,
  handleCallSearch,
  setCustomerModal,
  setBillToCustomerModal,
  resetValues,
  setCustomerNumber,
  resetErpOrderSearchData,
  hanleAGChange,
  hanleNCRSiteChange,
  setErpManualOrder_SaR,
  resetValuesMultipleInput,
  resetCustomerModalValues,
  resetOnReturn,
} = searchAndRetrieveSalesOrderSlice.actions;
export default searchAndRetrieveSalesOrderSlice.reducer;
